import React from "react";
import styled from "styled-components";

import FeatureRenderer from "components/Feature/RendererContainer";

const Container = styled.div.attrs({ className: "watermark" })`
  &::after {
    content: "Sample";
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 130px;
    opacity: 0.2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const SampleWatermark = () => {
  return (
    <FeatureRenderer feature="FeeReportGeneration" value={false} showUnset>
      <Container />
    </FeatureRenderer>
  );
};

export default SampleWatermark;
